@if (displayMustScanAQrCodeToSelectOnSiteLocationError()) {
  <div class="rounded bg-error-50 px-4 py-3 font-base text-sm text-error-700">
    {{ 'errors.on-site-location-required' | translate }}
  </div>
}

<app-custom-select-atom
  [items]="onSiteLocations ?? []"
  *ngIf="displayOnSiteLocationSelect"
  [selectedItem]="selectedOnSiteLocationId"
  (selectItem)="onOnSiteLocationChanged($event)"
  [isDisable]="!!(basketUserId$ | async) && (basketUserId$ | async) !== (userId$ | async)"
></app-custom-select-atom>
